import {
  CARE_QUALITY,
  CHRONIC_PREVALENCE,
  CHRONIC_PREVALENCE_BY_CONDITION,
  CARE_QUALITY_INTERNAL,
  CLAIMS_METRICS,
  DISEASE_PRELAVENCE,
  DISEASE_PRELAVENCE_BY_CONDITION,
  ENROLLMENT_METRICS,
  EPISODES_OF_CARE,
  EPISODES_OF_CARE_SELECTED,
  HIGH_COST_CLAIMS,
  HOME_ROUTE,
  HOME_SCREEN,
  LOGIN,
  LOGIN_CALLBACK,
  LOGIN_REDIRECT,
  MED_PHARMA,
  MEMBER_SUMMARY,
  NETWORK_LEAKAGE,
  OTHER_PRESCRIPTION,
  PATIENT_ADMISSION,
  PATIENT_DETAILS,
  PENDING_CLAIMS,
  PLAN_PERFORMANCE,
  PROCEDURE_UTILIZATION,
  PROVIDER_UTILIZATION,
  REJECTED_CLAIMS,
  REPORTS,
  REPORT_PLAN,
  RISING_RISK,
  RISING_RISK_DETAILS,
  RISK_PATIENT_DETAILS,
  RX_UTILIZATION,
  SIGNUP,
  SPECIALITY_DRUGS,
  SPECIFIC_DEDUCTIBLE_CORRIDORS,
  STOPLOSS_TRIGGERS,
  SUMMARY,
  WASTE_CALCULATOR,
  WASTE_CALCULATOR_DETAILS,
  KPI_TRACKER,
  KPI_TRACKER_INTERNAL,
  CONTRACT_AIQ,
  CONTRACT_AIQ_INTERNAL,
  ONBOARDING,
  ONBOARDINGSTATUS,
  PLAYBOOK,
  CONTRACT_AIQ_REPORTS,
  ACCESS_DASHBOARD,
  ACCESS_DASHBOARD_INTERNAL,
  COMPLIANCE_ASSURANCE,
  PLAN_DOCUMENTS_INTERNAL,
  CUSTOM_ANALYSIS,
  RECOMMENDATIONS,
  CLAIM_ANALYSIS,
  TASK_BOARD,
  COMPLIANCE_REPORT,
  STOPLOSS_REPORT,
  PLAYBOOK_INTERNAL_PAGE,
  PLAYBOOK_DETAILS,
  REGULATORY_COMPLIANCE_REPORT,
  PURCHASING_STANDARDS_REPORT,
  COMPENSATION_TRANSPARENCY_REPORT,
  INTER_CONTRACT_REPORT,
  GAG_CLAUSE_REPORT,
  REPORTS_PPT,
  RISK_PROFILING_BY_CHRONIC,
  RISK_PROFILING_BY_COST,
  RISK_PROFILING_BY_TRIGGER,
  RISK_PROFILING_BY_UTILIZATION,
  GLP_DRUGS,
  RISK_PROFILING_BY_DRUGS,
  MEMBER_LIST,
  CONTRACT_ONBOARDING,
  SAVINGS_UTILIZATION,
  DATA_CATALOGUE,
  MERGE_DOCUMENTS,
  CARE_NAVIGATOR,
  PATIENT_CASES,
  CARE_NAVIGATOR_PROFILE,
  PROFILE,
  STOPLOSS_TRIGGERS_INTERNAL,
  DRAFT_AGREEMENTS,
  DRAFT_SELECTED,
  PLAN_DOCUMENTS,
  MA_DUE_DILIGENCE,
  MA_DUE_DILIGENCE_INTERNAL,
  MA_DUE_DILIGENCE_ADD,
  DOC_COMPARISON,
  FINANCIAL_FORENSICS,
  RISK_REGISTER,
  EXPERICENCE_SCREEN,
  SCENARIO_WORKSPACE,
  SCENARIO_LIBRARY,
  RECONCILIATION_LIBRARY,
  RECONCILIATION_WORKSPACE,
  DEEP_DIVE,
  TERM_COMPILER,
  NEW_TERM_COMPILER,
  TERM_COMPILER_INTERNAL,
  CLAIMS_LIST,
  DOC_COMP_INTEGRAL,
  NEW_DOC_COMPARISON,
  TREND_ANALYSIS,
  TREND_ANALYSIS_INTERNAL,
  ANNUAL_RENEWAL_PROCESS,
  RENEWAL_DETAILS,
  PLAYBOOK_AND_STANDARD,
  PLAYBOOK_AND_STANDARD_INTERNAL,
  PAYMENT_INTEGRITY,
  PAYMENT_INTEGRITY_INTERNAL,
  CMS_BENCHMARK,
  CMS_BENCHMARK_INTERNAL,
  COHORT_COMPARISON,
  COHORT_COMPARISON_INTERNAL,
  PROPOSAL_ANALYZER,
} from '../routes';

export const UserAccessConstants = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  USER: 'user',
  NURSE: 'care_navigator_nurse',
  PHARMACIST: 'care_navigator_pharmacist',
  CUSTOMER_SERVICE: 'care_navigator_customer_service',
  SUMMARY: 'SUMMARY',
  DISEASE_MANAGEMENT: 'DISEASE_MANAGEMENT',
  COST_MANAGEMENT: 'COST_MANAGEMENT',
  STOP_LOSS_MANAGEMENT: 'STOP_LOSS_MANAGEMENT',
  PLAN_ANALYSIS: 'PLAN_ANALYSIS',
  CLAIMS_MANAGEMENT: 'CLAIMS_MANAGEMENT',
  MEDICAL_CLAIM_UTILIZATION: 'MEDICAL_CLAIM_UTILIZATION',
  DRUG_UTILIZATION: 'DRUG_UTILIZATION',
  RISK_PROFILE: 'RISK_PROFILE',
  COMPLIANCE_ASSURANCE: 'COMPLIANCE_ASSURANCE',
  CUSTOM_QUERY_BUILDER: 'CUSTOM_QUERY_BUILDER',
  KPI_TRACKER: 'KPI_TRACKER',
  REPORTS: 'REPORTS',
  CLAIM_ANALYSIS: 'CLAIM_ANALYSIS',
  CONTRACT_ANALYSIS: 'CONTRACT_ANALYSIS',
  TASK_BOARD: 'TASK_BOARD',
  RISK_REGISTER: 'RISK_REGISTER',
  COHORT_DETAILS: 'COHORT_DETAILS',
  CUSTOM_DASHBOARD: 'CUSTOM_DASHBOARD',
  CUSTOM_REPORTS: 'CUSTOM_REPORTS',
  DATA_CATALOGUE: 'DATA_CATALOGUE',
  CARE_NAVIGATION: 'CARE_NAVIGATION',
  MEMBER_IDENTIFICATION: 'MEMBER_IDENTIFICATION',
  EXPERIENCE: 'EXPERIENCE',
  FISCAL_CONTROL: 'FISCAL_CONTROL',
  DEEP_DIVE: 'DEEP_DIVE',
  TREND_ANALYSIS: 'TREND_ANALYSIS',
  COHORT_COMPARISON: 'COHORT_COMPARISON',
};

export const UserConstants = {
  SUPER_ADMIN: 'Super Admin',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  EMAIL_ID: 'emailID',
  ROLE: 'role',
};

export const TotalFeatures = [
  'SUMMARY',
  'DISEASE_MANAGEMENT',
  'COST_MANAGEMENT',
  'STOP_LOSS_MANAGEMENT',
  'PLAN_ANALYSIS',
  'CLAIMS_MANAGEMENT',
  'MEDICAL_CLAIM_UTILIZATION',
  'DRUG_UTILIZATION',
  'RISK_PROFILE',
  'COMPLIANCE_ASSURANCE',
  'CUSTOM_QUERY_BUILDER',
  'KPI_TRACKER',
  'REPORTS',
  'CLAIM_ANALYSIS',
  'CONTRACT_ANALYSIS',
  'TASK_BOARD',
  'COHORT_DETAILS',
  'CUSTOM_DASHBOARD',
  'CUSTOM_REPORTS',
  'DATA_CATALOGUE',
  'CARE_NAVIGATION',
  'MEMBER_IDENTIFICATION',
  'RISK_REGISTER',
  'EXPERIENCE',
  'FISCAL_CONTROL',
  'DEEP_DIVE',
  'TREND_ANALYSIS',
  'PAYMENT_INTEGRITY',
  'CMS_BENCHMARK',
  'COHORT_COMPARISON',
];

export const userAccessRouteNameMap = new Map<string, string[]>();
userAccessRouteNameMap.set('SUMMARY', [
  SUMMARY,
  RISK_PATIENT_DETAILS,
  PATIENT_DETAILS,
]);
userAccessRouteNameMap.set('DISEASE_MANAGEMENT', [
  DISEASE_PRELAVENCE,
  DISEASE_PRELAVENCE_BY_CONDITION,
  PATIENT_DETAILS,
  CHRONIC_PREVALENCE,
  CHRONIC_PREVALENCE_BY_CONDITION,
  RISING_RISK,
  RISING_RISK_DETAILS,
  CARE_QUALITY,
  CARE_QUALITY_INTERNAL,
]);
userAccessRouteNameMap.set('COST_MANAGEMENT', [
  EPISODES_OF_CARE,
  EPISODES_OF_CARE_SELECTED,
  PATIENT_DETAILS,
  WASTE_CALCULATOR,
  WASTE_CALCULATOR_DETAILS,
  HIGH_COST_CLAIMS,
  MEMBER_SUMMARY,
]);
userAccessRouteNameMap.set('STOP_LOSS_MANAGEMENT', [
  STOPLOSS_REPORT,
  REPORT_PLAN,
  STOPLOSS_TRIGGERS,
  STOPLOSS_TRIGGERS_INTERNAL,
  SPECIFIC_DEDUCTIBLE_CORRIDORS,
]);
userAccessRouteNameMap.set('PLAN_ANALYSIS', [
  PLAN_PERFORMANCE,
  CLAIMS_METRICS,
  ENROLLMENT_METRICS,
  NETWORK_LEAKAGE,
]);
userAccessRouteNameMap.set('CLAIMS_MANAGEMENT', [
  PENDING_CLAIMS,
  REJECTED_CLAIMS,
]);
userAccessRouteNameMap.set('MEDICAL_CLAIM_UTILIZATION', [
  PATIENT_ADMISSION,
  PROCEDURE_UTILIZATION,
  PROVIDER_UTILIZATION,
  MED_PHARMA,
]);
userAccessRouteNameMap.set('DRUG_UTILIZATION', [
  MED_PHARMA,
  SPECIALITY_DRUGS,
  OTHER_PRESCRIPTION,
  RX_UTILIZATION,
  GLP_DRUGS,
  SAVINGS_UTILIZATION,
]);
userAccessRouteNameMap.set('RISK_PROFILE', [
  RISK_PROFILING_BY_CHRONIC,
  RISK_PROFILING_BY_TRIGGER,
  RISK_PROFILING_BY_COST,
  RISK_PROFILING_BY_UTILIZATION,
  RISK_PROFILING_BY_DRUGS,
]);
userAccessRouteNameMap.set('KPI_TRACKER', [KPI_TRACKER, KPI_TRACKER_INTERNAL]);
userAccessRouteNameMap.set('REPORTS', [REPORTS, REPORTS_PPT]);
userAccessRouteNameMap.set('CLAIM_ANALYSIS', [CLAIM_ANALYSIS]);
userAccessRouteNameMap.set('TASK_BOARD', [TASK_BOARD]);
userAccessRouteNameMap.set('DEEP_DIVE', [DEEP_DIVE]);
userAccessRouteNameMap.set('TREND_ANALYSIS', [
  TREND_ANALYSIS,
  TREND_ANALYSIS_INTERNAL,
]);
userAccessRouteNameMap.set('COHORT_COMPARISON', [
  COHORT_COMPARISON,
  COHORT_COMPARISON_INTERNAL,
]);
userAccessRouteNameMap.set('EXPERIENCE', [EXPERICENCE_SCREEN]);
userAccessRouteNameMap.set('RISK_REGISTER', [RISK_REGISTER]);
userAccessRouteNameMap.set('DATA_CATALOGUE', [DATA_CATALOGUE]);
userAccessRouteNameMap.set('DATA_SPHERE', [DATA_CATALOGUE]);
userAccessRouteNameMap.set('CARE_NAVIGATION', [
  CARE_NAVIGATOR,
  PATIENT_CASES,
  CARE_NAVIGATOR_PROFILE,
  PATIENT_DETAILS,
  PLAN_DOCUMENTS_INTERNAL,
]);
userAccessRouteNameMap.set('FISCAL_CONTROL', [
  FINANCIAL_FORENSICS,
  SCENARIO_WORKSPACE,
  SCENARIO_LIBRARY,
  RECONCILIATION_LIBRARY,
  RECONCILIATION_WORKSPACE,
]);
userAccessRouteNameMap.set('MEMBERS_LIST', [MEMBER_LIST]);
userAccessRouteNameMap.set('CLAIMS_LIST', [CLAIMS_LIST]);
userAccessRouteNameMap.set('DUE_DILIGENCE', [
  MA_DUE_DILIGENCE,
  MA_DUE_DILIGENCE_ADD,
  MA_DUE_DILIGENCE_INTERNAL,
]);
userAccessRouteNameMap.set('TERM_COMPILER', [
  TERM_COMPILER,
  TERM_COMPILER_INTERNAL,
  NEW_TERM_COMPILER,
]);
userAccessRouteNameMap.set('DOC_COMPARISON', [
  DOC_COMPARISON,
  DOC_COMP_INTEGRAL,
  NEW_DOC_COMPARISON,
]);
userAccessRouteNameMap.set('DRAFT_ANALYZER', [
  DRAFT_AGREEMENTS,
  DRAFT_SELECTED,
]);
userAccessRouteNameMap.set('CONTRACT_ANALYSIS', [
  PLAN_DOCUMENTS,
  PLAN_DOCUMENTS_INTERNAL,
  CONTRACT_AIQ,
  CONTRACT_AIQ_INTERNAL,

  PLAYBOOK,
  CONTRACT_AIQ_REPORTS,
  COMPLIANCE_REPORT,
  PLAYBOOK_INTERNAL_PAGE,
  PLAYBOOK_DETAILS,
  PLAN_DOCUMENTS,
  PLAN_DOCUMENTS_INTERNAL,
  REGULATORY_COMPLIANCE_REPORT,
  PURCHASING_STANDARDS_REPORT,
  COMPENSATION_TRANSPARENCY_REPORT,
  INTER_CONTRACT_REPORT,
  GAG_CLAUSE_REPORT,
  CONTRACT_ONBOARDING,
  MERGE_DOCUMENTS,
]);
userAccessRouteNameMap.set('ANNUAL_RENEWAL_PROCESS', [
  ANNUAL_RENEWAL_PROCESS,
  RENEWAL_DETAILS,
]);
userAccessRouteNameMap.set('PLAYBOOK_AND_STANDARD', [
  PLAYBOOK_AND_STANDARD,
  PLAYBOOK_AND_STANDARD_INTERNAL,
]);
userAccessRouteNameMap.set('PAYMENT_INTEGRITY', [
  PAYMENT_INTEGRITY,
  PAYMENT_INTEGRITY_INTERNAL,
]);
userAccessRouteNameMap.set('CMS_BENCHMARK', [
  CMS_BENCHMARK,
  CMS_BENCHMARK_INTERNAL,
]);
userAccessRouteNameMap.set('PROPOSAL_ANALYZER', [PROPOSAL_ANALYZER]);

export const formatUserAccessRoutes = (userAccessResponseRoutes: string[]) => {
  const userAccessRoutes = [
    LOGIN,
    LOGIN_CALLBACK,
    LOGIN_REDIRECT,
    HOME_ROUTE,
    HOME_SCREEN,
    SIGNUP,
    // REPORTS,
    ONBOARDING,
    ONBOARDINGSTATUS,
    ACCESS_DASHBOARD,
    ACCESS_DASHBOARD_INTERNAL,
    COMPLIANCE_ASSURANCE,
    CUSTOM_ANALYSIS,
    RECOMMENDATIONS,
    PROFILE,
  ];

  const userFeatures: string[] = [];

  userAccessResponseRoutes.forEach((route) => {
    if (!userFeatures.includes(route)) {
      userFeatures.push(route);
      userAccessRoutes.push(...(userAccessRouteNameMap.get(route) ?? []));
    }
  });

  return { userFeatures, userAccessRoutes };
};

export const checkUserAccess = (
  feature: string,
  role: string,
  accessibleFeatues: string[],
) => {
  switch (role) {
    case UserAccessConstants.SUPER_ADMIN:
      return true;

    case UserAccessConstants.ADMIN:
    case UserAccessConstants.USER:
      return accessibleFeatues.includes(feature);
  }
  return false;
};
export const isCardFeatureAccessible = (
  cardPath: string,
  accessibleFeatures: string[],
  role: string,
) => {
  if (role === UserAccessConstants.SUPER_ADMIN) {
    return true;
  }

  for (const feature of accessibleFeatures) {
    const allowedRoutes = userAccessRouteNameMap.get(feature) || [];
    if (allowedRoutes.includes(cardPath)) {
      return true;
    }
  }
  return false;
};

export const isFeatureAccessible = (
  accessRoute: string,
  combinedScreens: string[],
  userAccess: any,
): boolean => {
  const isAdmin = userAccess.role.name;
  if (isAdmin === 'super_admin') {
    return true;
  }
  return combinedScreens.includes(accessRoute);
};
